/**
 * Custom Amplify Auth Hub channel to allow us to send and listen for
 * DART-specific auth events (e.g. fetching a jwt).
 *
 * **Usage**
 * Use in conjunction with the Hub provided by Amplify's Auth solution.
 */
export const DART_AUTH_CHANNEL = "dartCustomAuth";
